import { render, staticRenderFns } from "./FranchiseMonitorComponent.vue?vue&type=template&id=9244a5a4&scoped=true"
import script from "./FranchiseMonitorComponent.vue?vue&type=script&lang=js"
export * from "./FranchiseMonitorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9244a5a4",
  null
  
)

export default component.exports